import { homeRoute } from './../../core/routing/route-names';
import { OnInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { ChangePasswordDTO, UserAccountClient } from '../models/models.swagger.generated';
import { ToastService } from '../services/toast.service';
import { passwordValidation } from '../../directives/password-validation.directive';
import { TranslateModule } from '@ngx-translate/core';
import { AppErrorMessagesComponent } from '../error-messages/app-error-messages.component';
import { TitleBarComponent } from '../shared/title-bar/title-bar.component';

import { PasswordVisibilityDirective } from 'src/app/directives/password-visibility.directive';
import { MarkAsteriskDirective } from 'src/app/directives/mark-asterisk.directive';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    imports: [AppErrorMessagesComponent, TitleBarComponent, TranslateModule, ReactiveFormsModule, PasswordVisibilityDirective, MarkAsteriskDirective]
})
export class ChangePasswordComponent implements OnInit {
  public loading = false;
  public changePasswordForm: UntypedFormGroup;
  public oldPasswordControl: UntypedFormControl;
  public newPasswordControl: UntypedFormControl;
  public newPasswordConfirmControl: UntypedFormControl;
  private newPasswordConfirm: string;
  private changePasswordDTO: ChangePasswordDTO;

  constructor(
    private router: Router,
    private userAccountClient: UserAccountClient,
    private toastService: ToastService) {
  }

  ngOnInit() {
    this.initializeForm();
  }

  hasValidPasswords(group: UntypedFormGroup): boolean {
    const pass = group.get('newPassword').value;
    const confirmPass = group.get('newPasswordConfirm').value;

    if (pass !== confirmPass) {
      this.loading = false;
      this.toastService.showError(
        'i18n.core.messages.changePassword.title',
        'i18n.core.messages.changePassword.pwdDoNotMatch');
      return false;
    }

    return true;
  }

  public changePassword(): void {
    this.loading = true;

    this.changePasswordDTO = new ChangePasswordDTO();
    this.changePasswordDTO.oldPassword = this.changePasswordForm.value.oldPassword;
    this.changePasswordDTO.newPassword = this.changePasswordForm.value.newPassword;
    this.newPasswordConfirm = this.changePasswordForm.value.newPasswordConfirm;

    if (!this.hasValidPasswords(this.changePasswordForm)) {
      return;
    }

    // if (this.changePasswordDTO.newPassword != this.newPasswordConfirm){
    // if (!this.checkPasswords(this.changePasswordForm)) {
    //   this.loading = false;

    //   this.toastService.showError(
    //     'i18n.core.messages.changePassword.title',
    //     'i18n.core.messages.changePassword.pwdDoNotMatch');
    //     return;
    // }


    this.userAccountClient.changePassword(this.changePasswordDTO).subscribe(
      result => {
        this.loading = false;

        if (result) {
          this.router.navigate([homeRoute]);
        }
      },
      error => {
        this.loading = false;

        this.toastService.showError(
          'i18n.core.messages.changePassword.title',
          'i18n.core.messages.changePassword.message');
      }
    );
  }

  private initializeForm(): void {
    this.oldPasswordControl = new UntypedFormControl('', [Validators.required]);
    this.newPasswordControl = new UntypedFormControl('', [Validators.required, passwordValidation()]);
    this.newPasswordConfirmControl = new UntypedFormControl('', [Validators.required, passwordValidation()]);
    this.changePasswordForm = new UntypedFormGroup({
      oldPassword: this.oldPasswordControl,
      newPassword: this.newPasswordControl,
      newPasswordConfirm: this.newPasswordConfirmControl
    });
  }
}
